import React from "react";
import { Alert } from "react-bootstrap";

import { BessAviso, BessParametros, BessResumoGeral } from "../../types";

interface BessAlertsProps {
  resumo: BessResumoGeral;
  parametros: BessParametros;
  avisos: BessAviso[];
}

// Campo do formulário que cada aviso do backend questiona. Códigos fora do mapa
// são exibidos como aviso genérico — o catálogo do backend pode crescer.
const CAMPO_POR_AVISO: Record<string, string> = {
  CONSUMO_PONTA_DIVERGENTE_MEDICAO: "Consumo de Ponta",
  CONSUMO_FORA_PONTA_DIVERGENTE_MEDICAO: "Consumo Fora de Ponta",
  GERACAO_MEDIDA_IGNORADA_USINA_NOVA: "Geração",
  GERACAO_DIVERGENTE_MEDICAO: "Geração",
};

export const BessAlerts: React.FC<BessAlertsProps> = ({
  resumo,
  parametros,
  avisos,
}) => {
  const anoMedicao = Number(parametros.mesReferencia.split("/")[1]);
  const pldDivergente = resumo.pldAnoUtilizado !== anoMedicao;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {avisos.map((aviso) => (
        <Alert key={aviso.codigo} variant="warning">
          {CAMPO_POR_AVISO[aviso.codigo] && (
            <strong>{CAMPO_POR_AVISO[aviso.codigo]}: </strong>
          )}
          {aviso.mensagem}
        </Alert>
      ))}

      {resumo.horasFaltantes > 0 && (
        <Alert variant="warning">
          {resumo.horasFaltantes === 1
            ? "Medição incompleta: 1 hora ausente na medição ficou indisponível para operação da bateria e fica fora do cálculo de MCP, que sai parcial e subestima o mês cheio."
            : `Medição incompleta: ${resumo.horasFaltantes} horas ausentes na medição ficaram indisponíveis para operação da bateria e ficam fora do cálculo de MCP, que sai parcial e subestima o mês cheio.`}
        </Alert>
      )}

      {pldDivergente && (
        <Alert variant="warning">
          PLD estimado: o PLD horário de {anoMedicao} não estava disponível — a
          simulação usou o PLD de {resumo.pldAnoUtilizado}. Trate o resultado de
          MCP como estimativa.
        </Alert>
      )}
    </div>
  );
};
